export const blockIconsSocialShare = (
	<span className='material-symbols-outlined'>share</span>
);
